module.exports = __webpack_public_path__ + "media/lan/LogoColorIcon-2a69fd4c.png";